const theme = {
  colors: {
    // Core palette
    primary: '#6366f1',
    primaryLight: '#818cf8',
    primaryDark: '#4f46e5',
    accent: '#06b6d4',
    accentLight: '#22d3ee',
    secondary: '#f43f5e',

    // Backgrounds — solid colors, no transparency overhead
    background: '#030014',
    backgroundAlt: '#060620',
    surface: '#0c0c24',
    surfaceLight: '#121230',

    // Text
    text: '#f1f5f9',
    textSecondary: '#94a3b8',
    textMuted: '#64748b',

    // Utility
    border: 'rgba(99, 102, 241, 0.15)',
    borderLight: 'rgba(255, 255, 255, 0.06)',
    glow: 'rgba(99, 102, 241, 0.4)',
    glowCyan: 'rgba(6, 182, 212, 0.4)',

    // Gradients
    gradientPrimary: 'linear-gradient(135deg, #6366f1 0%, #06b6d4 100%)',
    gradientText: 'linear-gradient(135deg, #f1f5f9 0%, #6366f1 50%, #06b6d4 100%)',
    gradientCard: 'linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(6, 182, 212, 0.05) 100%)',
    gradientDark: 'linear-gradient(180deg, #030014 0%, #0a0a1a 100%)',
  },

  fonts: {
    heading: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    mono: "'JetBrains Mono', 'Fira Code', monospace",
  },

  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },

  // Solid card styles instead of expensive backdrop-filter
  card: {
    background: '#0c0c24',
    border: '1px solid rgba(255, 255, 255, 0.06)',
    shadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
  },

  transitions: {
    fast: '0.15s ease',
    standard: '0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    smooth: '0.5s cubic-bezier(0.4, 0, 0.2, 1)',
    spring: '0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },

  spacing: {
    section: '100px',
    sectionMobile: '70px',
  }
};

export default theme;
